import Vue from 'vue'
import Vuex from 'vuex'
import GLOBAL from '@/assets/js/global.js';
// import {getproductByIndex} from '@/data/getdata.js'
  
Vue.use(Vuex)
const key ='token'
const ua = {}
 
const store =new Vuex.Store({
 state(){
   return{
     token:localStorage.getItem('token') ? localStorage.getItem('token'):'',
     code:localStorage.getItem('code') ? localStorage.getItem('code'):'',
     ua : localStorage.getItem('ua') ? JSON.parse(localStorage.getItem('ua')):{},
     userinfo : localStorage.getItem('userinfo') ? JSON.parse(localStorage.getItem('userinfo')):{},
     tipsimg : GLOBAL.tipsImg,
     tjlSwitch : localStorage.getItem('tjlSwitch') ? localStorage.getItem('tjlSwitch'):'',
     m3b : localStorage.getItem('m3b') ? localStorage.getItem('m3b'):0,
   }
 },
  getters:{
    getSortage:function (state) {
      if(!state.token){
        state.token = localStorage.getItem('token')
      }
      return state.token
    },
    getcode: function(state){
      state.code = localStorage.getItem('code')
      return state.code
  },    
    getaccount: function(state){
      state.ua= localStorage.getItem('ua') ? JSON.parse(localStorage.getItem('ua')) : {}
      return state.ua || {}
    },
    getlogin: function(state){
        state.login = localStorage.getItem('login')
        return state.login
    },
    getuserinfo: function(state){
      state.userinfo = localStorage.getItem('userinfo') ? JSON.parse(localStorage.getItem('userinfo')) : {}
      return state.userinfo
    },
    getm3b: function(state){
      state.m3b = parseInt(localStorage.getItem('m3b'));
      return state.m3b;
    },    
    gettipsimg: function(state){
      return state.tipsimg
    },
    gettjlSwitch: function(state){
      return state.tjlSwitch
    },            
  },
  mutations:{
   $_setStorage(state,value){
     state.token =value;
     localStorage.setItem('token',value)
    //  localStorage.setItem(key,JSON.stringify(value))
   },
   $_setCode(state,value){
    state.code =value;
    //localStorage.setItem('token',value)
   //  localStorage.setItem(key,JSON.stringify(value))
  },   
   $_setAccount(state,account_ua){
     state.ua =account_ua
     localStorage.setItem("ua",JSON.stringify(account_ua))
 
    //  localStorage.setItem(account,JSON.stringify(account))
   },
   $_setLogin(state,value){
    state.login = value
    localStorage.setItem("login",value)

   //  localStorage.setItem(account,JSON.stringify(account))
   },
   $_setUserinfo(state,value){
    if(typeof value == 'undefined')return;
    state.userinfo = value
    localStorage.setItem("userinfo",JSON.stringify(value))

   //  localStorage.setItem(account,JSON.stringify(account))
   },
   $_setm3b(state,value){
    if(typeof value == 'undefined')return;
    state.m3b = value
    localStorage.setItem("m3b",parseInt(value))

   //  localStorage.setItem(account,JSON.stringify(account))
   },   
   $_setTjlSwitch(state,value){
    state.tjlSwitch =value;
    localStorage.setItem('tjlSwitch',value)
   //  localStorage.setItem(key,JSON.stringify(value))
  },         
  },
})
export default store


// WEBPACK FOOTER //
// ./src/pages/index/store.js